import { render, staticRenderFns } from "./invitePage.vue?vue&type=template&id=64953467&scoped=true"
import script from "./invitePage.vue?vue&type=script&lang=js"
export * from "./invitePage.vue?vue&type=script&lang=js"
import style0 from "./invitePage.vue?vue&type=style&index=0&id=64953467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64953467",
  null
  
)

export default component.exports